import styled from 'styled-components';
import { animated } from 'react-spring';

export const Container = styled(animated.section)`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.theme.colors.promptBackgroundColor};
  overflow: visible;
  z-index: 9999999;
`;

export const Panel = styled.div` 
  background-color: ${(props) => props.theme.colors.promptPanelBackgroundColor};
  max-width: 536px;
  width: 100%;
  border-radius: 20px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.05);

  button:not(.negative) {
    background-color: ${(props) => props.theme.colors.promptOkButtonColor};
  }

  .input-label {
    display: block;
    margin-bottom: 20px;
    color: #610082;
    font-size: 1.4rem;
    font-weight: 900;
    line-height: 16px;
  }

`;

export const Body = styled.div`
  padding: 20px 20px;
  min-height: 133px;
  max-height: 211px;
  overflow: hidden;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: flex-end;
`;

export const BodyContent = styled.div`
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: center;

  * {
    color: ${(props) => props.theme.colors.promptTextColor};
    font-size: 20px;
  }

`;

export const IconContentPart = styled.div`
  padding: 5px;
`;

export const TextContentPart = styled.div`
  padding: 5px;
  display: inline-block;
  text-align: center;
  font-weight: 300;
`;

export const Actions = styled.div`
  padding: 20px 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

// new prompt evolutive
export const PanelEvolutive = styled.div`
  border-radius: 6px;
  background-color: #18191B;
  border-top: 5px solid ${(props) => props.theme.colors.secondary};
  padding: 20px;

  width: 420px;
  min-height: 227px;
`

export const PanelEvolutiveHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 16px 0 30px 0;
  border-bottom: 1px solid #4C555C;

  .iconHeader {
    width: 21px;
    height: 21px;

    path {
      fill: ${(props) => props.theme.colors.secondary};
    }
  }
`

export const PanelEvolutiveTitle = styled.h1`
  font-weight: 400;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.constrat};
`

export const PanelEvolutiveBody = styled.div`
  padding: 30px 0;
`

export const PanelEvolutiveBodyText = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${(props) => props.theme.colors.constrat};
`

export const PanelEvolutiveActions = styled.div`
  display: flex;
  justify-content: space-between;
`

const PanelEvolutiveButton = styled.button`
  padding: 10px 40px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => props.theme.colors.constrat};
  text-transform: uppercase;
  background-color: transparent;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    filter: brightness(0.7);
  }
`

export const PanelEvolutiveActionCancel = styled(PanelEvolutiveButton)`
  color: ${(props) => props.theme.colors.text.placeholder};
  border: 1px solid ${(props) => props.theme.colors.text.placeholder};
`

export const PanelEvolutiveActionActive  = styled(PanelEvolutiveButton)`
  color: ${(props) => props.theme.colors.constrat};
  background-color: ${(props) => props.theme.colors.backgroundItemColor};
`
